import { ThemeCatDataviz, ThemeSeqDataviz, ThemeStyles } from '@platform-ui-kit/components-library'

export const getPalette = <
  T extends ThemeCatDataviz | ThemeSeqDataviz | Pick<ThemeStyles['color'], 'primary' | 'grey'> | object,
>(
  keys: (keyof T)[],
  themePart: T,
): string[][] => keys.map(key => Object.values(themePart[key] as Record<string, string>))
